import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
  getOfferResponses,
  deleteOfferResponse,
  exportPdf,
} from "./modules/actions";

const mapStateToProps = (state) => ({
  state: {
    offerResponses: state.offerResponseReducer.offerResponses,
  },
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      getOfferResponses,
      deleteOfferResponse,
      exportPdf,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
